export const colors = {
  primary1: '#FFCB03',
  primary2: '#FFE78D',
  primary3: '#FFECA4',
  primary4: '#FFF6D1',
  primary5: '#F9F2EF',

  secondary1: '#FF573E',
  secondary2: '#FFBDA7',
  secondary3: '#FFE7DA',
  secondary4: '#FFF3ED',

  tertiary1: '#3C71DA',
  tertiary2: '#DFE4F3',
  tertiary3: '#fcf1ed',
  tertiary4: '#F5F8FF',
  tertiary5: '#B0C5F1',

  quatertiary1: '#5EA237',
  quatertiary2: '#D3ECD3',
  quatertiary3: '#F4F6FB',

  overlay: 'rgba(60, 113, 218, 0.15)',

  blue100: '#F4F6FB',
  blue150: '#F4F6FB',
  blue200: '#DFE4F3',
  blue400: '#B0C5F1',
  blue600: '#3C71DA',
  blue800: '#305AAE',

  red100: '#FFF3ED',
  red600: '#FF573E',

  green100: '#F2F9F2',
  green200: '#D3ECD3',
  green600: '#5EA237',

  yellow100: '#FFF6D1',
  yellow200: '#FFECA4',
  yellow400: '#FFE78D',
  yellow600: '#FFCB03',

  grey1: '#83807f',
  grey2: '#f4f4f4',
  grey3: '#eaeaea',
  grey4: '#9a9897',
  grey5: '#E2E2E2',
  grey6: '#C4C4C4',

  danger: '#FF573E',
  success: '#3C71DA',

  black: '#000000',
  white: '#ffffff',
  borderSeparator: '#DFE4F3',

  black700: '#83807F',
};

export const space = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 40,
  8: 48,
  9: 56,
  10: 64,
  11: 72,
};

export const fonts = {
  default: 'Arial, Helvetica, sans-serif',
  family1: 'lf-antique-olive',
  family2: 'lf-aktiv-grotesk',
};

export const fontSizes = {
  xsm: 12,
  sm: 14,
  md: 16,
  xmd: 18,
  lg: 22,
  xl: 28,
  '2xl': 36,
  '3xl': 45,
};

export const fontWeight = {
  light: 400,
  base: 600,
  bold: 700,
  black: 900,
};

export const border = {
  primary: '1px solid #f5f5f5',
};

export const radii = {
  1: 4,
  2: 8,
  3: 16,
  4: 24,
  5: 32,
  6: 40,
  7: 60,
  round: '50%',
};

export const opacity = {
  linkHover: 0.6,
};

export const zindex = {
  base: 0,
  productPageCta: 980,
  sticky: 1000,
  fixed: 1020,
  dropdown: 1030,
  modalBackdrop: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070,
  toast: 1080,
};
